import { SVGProps, Ref, forwardRef } from 'react';

export const LockOpenedFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M21.219 3.687c.488.878.81 2.023.968 3.313H24c-.41-3.743-2.067-7-5.895-7-3.523 0-5.207 2.757-5.772 6.114C11.384 6.03 10.28 6 9 6c-7.875 0-9 1.125-9 9s1.125 9 9 9 9-1.125 9-9c0-5.692-.588-7.857-3.887-8.62.178-1.038.47-1.958.878-2.693.668-1.204 1.612-1.887 3.114-1.887s2.445.683 3.114 1.887M9.9 17.5H8.1v-5h1.8z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
LockOpenedFilledSize24Glyph.displayName = 'LockOpenedFilledSize24Glyph';
